import { useEffect, useRef, useState } from "react";
import "./TextChatAssistant.scss";
import Utils from "../../../utils";
import _ from "lodash";
import moment from "moment/moment";
import { t } from "i18next";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import axios from "axios";
import ThemeModal from "../../../components/ThemeModal/index.js";
import TypeText from "../../../components/TypeText/index.js";
import { toast } from "react-toastify";
import Tooltipcomponent from "../../../components/Tooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import HandleWithMic from "./HandleWithMic.js";

const TextChatAssistant = (props) => {
  const {
    userMessage,
    setUserMessage,
    setIsFormLoading,
    uuid,
    accessToken,
    pluginId,
    userFilelist,
    loading,
    setLoading,
    messages,
    setMessages,
    initialMessages,
    markFlag = false,
    activeTab,
    instanceObj,
    autostart = {
      status: false,
      question: {
        val: "",
        seq: null,
      },
    },
    chunks = [],
    chunkFlag = false,
    isStreaming = false,
    setIsStreaming,
    title = t("assistant"),
    refresh = false,
    currentInstanceId,
    initialValues,
    outputType,
    shouldShowAudioIcon,
    instanceData,
    instanceName,
    fetchDataShared,
    getUsersByInstanceName,
    filelist,
    assistantData,
  } = props;
  const inputRef = useRef(null);
  const chatMessagesRef = useRef(null);
  const location = useLocation();
  // const chatForm = useRef();
  //   const [modalFeedbackShow, setModalFeedbackShow] = useState(false);
  const [currentChunk, setCurrentChunk] = useState(null);
  const [stopStream, setStopStream] = useState(false);
  const user = Utils.getLocalStorageItem("currentUser");
  const proxyUser = Utils.getLocalStorageItem("_proxyuser");

  const queryParams = new URLSearchParams(location.search);
  const stateValue = queryParams.get("state"); // Gets the 'state' parameter

  const token = Utils.getLocalStorageItem("_t");
  // const initSession = typeof user == 'string' ? `${JSON.parse(user)?.clientUserId}_${plugin}` : "";
  const [sessionId, setSessionId] = useState("");
  const [plugin, setPlugin] = useState({});
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [needScroll, setNeedScroll] = useState(true);
  const [previewData, setPreviewData] = useState("");
  const [modalHeading, setModalHeading] = useState("Preview");
  let controller = useRef(null);
  let readerTerminator = null;
  const [visible, setVisible] = useState(false);
  const [micStatus, setMicStatus] = useState(true);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isChatStarted, setIsChatStarted] = useState(false);
  const [checkLoader, setcheckLoader] = useState(false);
  const playingRef = useRef(false);
  const [personaData, setPersonaData] = useState(null);
  const [customerName, setCustomerName] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [fileSuggestions, setFileSuggestions] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [soulData, setSoulData] = useState("");
  const audioRef = useRef();
  const micRef = useRef();
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
  const [isMicOn, setIsMicOn] = useState(false);
  const [resetText, setResetText] = useState("");
  const [audioMessage, setAudioMessage] = useState("");

  const [customers] = useState([
    {
      name: "Ken",
      gender: "Male",
      mood: "Anxious",
      images: ["/Ken.jpg", "/Ken-1.jpg", "/Ken-2.jpg"],
      voiceId: "onwK4e9ZLuTAKqWW03F9",
    },
    {
      name: "Roger",
      gender: "Male",
      mood: "Complaining",
      images: ["/Roger.jpg", "/Roger-1.jpg", "/Roger-2.jpg"],
      voiceId: "Yko7PKHZNXotIFUBG7I9",
    },
    {
      name: "Sue",
      gender: "Female",
      mood: "Calm and cooperative",
      images: ["/Sue.jpg", "/Sue-1.jpg", "/Sue-2.jpg"],
      voiceId: "pMsXgVXv3BLzUgSXRplE",
    },
  ]);

  const toggleVisibility = () => {
    setVisible(!visible);
  };
  const fetchDataTableData = async (uuid, index, fetchData = false) => {
    console.log("🚀 ~ fetchDataTableData ~ uuid, index:", uuid, index)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/knowledgeBase/getFiles`,
        {
          tableUuid: uuid,
          page: 1,
          search: "",
        },
        {
          headers: {
            "X-Access-Token": token,
          },
        }
      );

      if (!_.isEmpty(response?.data?.data)) {
        setTableData(response?.data?.data);
    }
    } catch (error) {
      toast.error(`${t("somethingWentWrong")}`);
    }
  };
  useEffect(() => {
    if (needScroll) {
      scrollToBottom();
    }
    if (document && document?.getElementById("question")) {
      document.getElementById("question").blur();
    }
    if (inputRef?.current) {
      inputRef?.current?.focus();
    }
  }, [messages]);

  const refreshOrNew = () => {
    window.addEventListener("scroll", handleScroll);
    if (
      autostart?.status &&
      messages.length <= 1 &&
      !getUsersByInstanceName(instanceData, instanceName)
    ) {
      callPredectionApi(autostart?.question?.val, autostart?.question?.seq);
    }
    if (needScroll) {
      scrollToBottom();
    }
    return () => window.removeEventListener("scroll", handleScroll);
  };

  useEffect(() => {
    if (refresh) {
      refreshOrNew();
    }
  }, [refresh]);

  let lastScrollY = window.scrollY;
  const handleScroll = () => {
    let direction = lastScrollY < window.scrollY ? "down" : "up";
    lastScrollY = window.scrollY;
    if (direction == "up") {
      setNeedScroll(false);
    }
  };
  useEffect(() => {
    setMessages(initialMessages);
    if(assistantData?.tableUuid?.length > 0){
    fetchDataTableData(assistantData?.tableUuid);
    }
    // alert(JSON.stringify(user.clientUserId))
    // console.log(typeof user)
    let initSession;
    if (stateValue === "openWithOwner") {
      initSession =
        typeof proxyUser == "string"
          ? `${JSON.parse(proxyUser)?.userid}_${pluginId}`
          : "";
    } else {
      initSession =
        typeof user == "string"
          ? `${JSON.parse(user)?.clientUserId}_${pluginId}`
          : "";
    }

    setSessionId(initSession);
    reset();
  }, [pluginId]);

  useEffect(() => {
    if (userMessage || prompt) {
      if (needScroll) {
        scrollToBottom();
      }

      if (prompt) {
        callPredectionApi(prompt?.msgChunks, null, true);
        setTimeout(() => setPrompt(null), 2000);
      } else {
        callPredectionApi(userMessage);
      }
      setIsFormLoading(true);
    }
  }, [userMessage, prompt]);

  useEffect(() => {
    const checkGoogleApi = () => {
      if (window.gapi) {
        // console.log('Google Platform API script loaded.', window.gapi);
      } else {
        console.log("Google Platform API script not loaded.");
      }
    };

    const intervalId = setInterval(checkGoogleApi, 1000);

    return () => clearInterval(intervalId);
  }, []);
  const fetchAndRefresh = async () => {
    const updatedMessages = initialMessages;

    if (getUsersByInstanceName(instanceData, instanceName)) {
      setMessages(updatedMessages);
      fetchDataShared();
    }
    if (autostart?.status && updatedMessages.length <= 1) {
      terminateRequest();
      callPredectionApi(autostart?.question?.val, autostart?.question?.seq);
    }
  };

  useEffect(() => {
    fetchAndRefresh();
  }, [instanceName]);

  const scrollToBottom = () => {
    var id = setTimeout(() => {
      chatMessagesRef?.current?.scroll({
        top: chatMessagesRef?.current.scrollHeight,
        behavior: "smooth",
      });
      window.scrollTo(0, document.body.scrollHeight);
    }, 50);
    clearTimeout(id);
  };
  const onPreviewClickHandler = (data) => {
    let first = data.indexOf("<!DOCTYPE html>") || data.indexOf("<html>");
    if (first != -1) {
      data = data.slice(first - 1, data.length - 1);
      let last = data.indexOf("</html>");
      if (last != -1) {
        data = data.slice(0, last + 7);
      }
    }
    setPreviewData(data);
    setShow(true);
  };

  const reset = () => {
    setUserMessage("");
    if (needScroll) {
      scrollToBottom();
    }
  };

  const callPredectionApi = async (message, seq = null, msgChunks = false) => {
    const micStatus = isMicOn;
    setIsMicOn(false);
    // if (outputType === "both") {
    micRef.current?.resetTranscript();
    setResetText("");
    // }
    setLoading(true);
    setNeedScroll(true);
    setIsStreaming(true);
    controller.current = new AbortController();
    try {
      // const url = `${process.env.REACT_APP_BASE_URL}appcore/prediction/${plugin?.pluginId}`;
      let url = `${process.env.REACT_APP_GENAI_STUDIO_URL}${process.env.REACT_APP_PREDICTION_URL}${uuid}`;
      const headers = {
        "content-type": "application/json",
        "x-access-token": accessToken,
      };
      let overrideConfig = {
        sessionId: sessionId,
        streaming: true,
      };
      if (!_.isEmpty(userFilelist)) {
        overrideConfig = {
          ...overrideConfig,
          weaviateIndex: userFilelist?.className,
        };
      }
      let payload = {
        question: message,
        overrideConfig,
        formData: initialValues, //tempformData,
        instanceId: currentInstanceId,
        contextId: instanceObj?.instanceUuid || "",
      };
      if (stateValue === "openWithOwner") {
        payload.proxyUser = true;
      }
      if (seq) {
        payload.seq = seq;
        payload.question = "";
        payload.autostart = true;
      }
      if (msgChunks) {
        payload.msgChunks = true;
      }
      let signal = controller.current.signal;
      const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
        signal: signal,
      };
      const response = await fetch(url, options);
      if (micStatus) {
        setIsMicOn(true);
      }

      const reader = response.body.getReader();
      readerTerminator = reader.cancel;
      let chunks = "";
      while (true) {
        const { done, value } = await reader.read();

        const chunkStr = new TextDecoder().decode(value);

        if (chunks !== chunkStr) chunks += chunkStr;
        var val = chunks;

        let first = val?.slice(0, 7);

        let last = val?.slice(val.length - 3);

        if (last === "```") {
          val = val?.slice(0, val.length - 3);
        }

        if (first === "```json") {
          val = val.slice(7);
        }

        first = val?.slice(0, 11);

        if (first === "```markdown") {
          val = val.slice(11);
        }
        // val = val.replaceAll(/\n/g, "");
        if (done) {
          // val = repairMarkdown(val);
          handleloaded(val);
          break;
        }

        // val = val + '"}}'
        try {
          let jsonvalue;
          if (val.trim().startsWith("{") || val.trim().startsWith("[")) {
            jsonvalue = Utils.repairJSON(val);
            jsonvalue = JSON.parse(jsonvalue);
          }
          if (jsonvalue?.statusCode) {
            setCurrentChunk(
              "I'm sorry, but I didn't understand your question. Could you please provide more details or context?"
            );
          } else {
            setCurrentChunk(val);
          }
        } catch (error) {
          setCurrentChunk(val);
        }
        // if (needScroll) {
        //   console.log('266',needScroll)
        //   scrollToBottom();
        // }
      }
    } catch (error) {
      if (error.message == "BodyStreamBuffer was aborted") {
        // handleloaded()
      } else {
        setIsFormLoading(false);
        setLoading(false);
        setIsMicOn(true);
      }
    }
  };

  const autoSubmit = async (message) => {
    if (message) {
      setUserMessage(message);
    }
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const message = inputRef.current.value;
    setUserMessage(message);
    inputRef.current.value = "";
    inputRef?.current?.focus();
  };

  const handleloaded = (val) => {
    if (val) {
      try {
        const userMsg = {
          type: "user",
          message: userMessage || prompt?.msgChunks,
          time: moment().format("DD/MM/YYYY hh:mm A"),
        };
        setMessages((prev) => [...prev, userMsg]);

        let jsonvalue;
        if (val.trim().startsWith("{") || val.trim().startsWith("[")) {
          jsonvalue = Utils.repairJSON(val);
          jsonvalue = JSON.parse(jsonvalue);
        }
        if (jsonvalue?.statusCode) {
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              type: "system",
              message: Utils.removeQuotes(
                "I'm sorry, but I didn't understand your question. Could you please provide more details or context?"
              ),
              status: "completed",
              time: moment().format("DD/MM/YYYY hh:mm A"),
            },
          ]);
        } else {
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              type: "system",
              message: Utils.removeQuotes(val),
              status: "completed",
              time: moment().format("DD/MM/YYYY hh:mm A"),
            },
          ]);
        }
      } catch (error) {
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            type: "system",
            message: Utils.removeQuotes(val),
            status: "completed",
            time: moment().format("DD/MM/YYYY hh:mm A"),
          },
        ]);
      }
    }
    setCurrentChunk(null);
    setIsFormLoading(false);
    if (needScroll) {
      scrollToBottom();
    }
    setLoading(false);
    setPrompt(null);
    setUserMessage("");
    setIsStreaming(false);
  };
  const handleInterrupt = () => {
    if ((loading || isStreaming) && outputType === "audio") {
      terminateRequest();
    }
  };
  let terminateRequest = () => {
    setLoading(false);
    setIsStreaming(false);
    setStopStream(true);
    handleloaded(currentChunk);
    if (controller.current) {
      controller.current.abort("Abbort");
    }
    // if (readerTerminator) {
    //   readerTerminator();
    // }
  };
  const replayTooltip = (isPlaying) => (
    <Tooltip id="tooltip">
      <span>{isPlaying ? "Pause audio" : "Play audio"}</span>
    </Tooltip>
  );

  const playAudio = (audioUrl) => {
    if (audioUrl) {
      playingRef.current = true;

      const audioPlayer = document.getElementById("audioPlayer");
      audioPlayer.src = audioUrl;
      audioPlayer.play();
      audioPlayer.onended = function () {
        playingRef.current = false;
        setMicStatus(true);
        setIsSpeaking(false);
        setCurrentPlayingIndex(null);
      };
    }
  };
  const replaySoulAvatar = (name, message) => {
    if (name === "sue") {
      personaData.conversationSend(message);
      setTimeout(() => setIsSpeaking(false), 3000);
      setTimeout(() => setMicStatus(true), 3000);
    }
  };

  const getVoiceIdByName = (name) => {
    const customer =
      customers.filter(
        (customer) => customer.name.toLowerCase() === name
      )?.[0] || {};
    return customer?.voiceId || "ThT5KcBeYPX3keUQqHPh";
  };
  const handleFileSuggestions = (value) => {
    const lastAtIndex = value.lastIndexOf("@");
    if (lastAtIndex === -1) {
      setShowSuggestions(false);
      setFileSuggestions([]);
      return;
    }

    const query = value.slice(lastAtIndex + 1).toLowerCase();

    // Get regular files
    const availableFiles = Array.isArray(userFilelist)
      ? userFilelist
      : Array.isArray(filelist)
      ? filelist
      : [];

    // Get table data files
    const availableTableFiles = Array.isArray(tableData)
      ? tableData.map((file) => ({
          ...file,
          isTableData: true,
        }))
      : [];

    // Combine both file lists
    const allFiles = [
      ...availableFiles.map((f) => ({ ...f, isTableData: false })),
      ...availableTableFiles,
    ];

    let matches = [];
    if (query.length === 0) {
      // Show all files when just typed @
      matches = allFiles.slice(0, 8);
    } else if (query.length <= 20) {
      // Filter files when typing after @
      matches = allFiles
        .filter(
          (file) => file.fileName && file.fileName.toLowerCase().includes(query)
        )
        .slice(0, 8);
    }
    setFileSuggestions(matches);
    setShowSuggestions(matches.length > 0);
  };

  const handleFileSelect = (selectedFileName) => {
    // First try to find in filelist
    let file = (filelist || []).find((f) => f.fileName === selectedFileName);

    // If not found in filelist, try to find in tableData
    if (!file) {
      file = (tableData || []).find((f) => f.fileName === selectedFileName);
    }

    if (!file) return;

    const textarea = inputRef.current;
    const value = textarea.value;
    const cursorPos = textarea.selectionStart;
    const lastAtIndex = value.lastIndexOf("@", cursorPos - 1);
    if (lastAtIndex === -1) return;

    const queryEnd =
      value.indexOf("\n", lastAtIndex) !== -1
        ? Math.min(value.indexOf("\n", lastAtIndex), cursorPos)
        : cursorPos;
    const before = value.slice(0, lastAtIndex);
    const after = value.slice(queryEnd);
    const newValue = `${before}@${selectedFileName} ${after}`;

    textarea.value = newValue;
    const newCursorPos = lastAtIndex + selectedFileName.length + 2;
    textarea.setSelectionRange(newCursorPos, newCursorPos);
    textarea.focus();

    setShowSuggestions(false);
    setFileSuggestions([]);
  };

  const getAudio = async (name, text) => {
    // setDataInitial({customer:name});
    if (name === "sue") {
      setSoulData(text);
    } else {
      // onReplay(text);
      name = name?.split(" ")[0];
      let vId = getVoiceIdByName(name);

      const url = process.env.REACT_APP_AUDIO_CHAT_VOICE_API_URL;
      const payload = { textInput: text.message, voiceID: vId };
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: JSON.stringify(payload),
      };
      const response = await fetch(url, options);
      if (response.ok) {
        setIsSpeaking(true);
        const audioBlob = await response.blob();

        const audioUrlBlob = URL.createObjectURL(audioBlob);
        // audioUrlToPlay.current = audioUrlBlob;
        // const audioList = audioQueueRef.current;
        // audioList.push(audioUrl);
        // audioQueueRef.current = audioList;
        // if (!playingRef.current) {
        playAudio(audioUrlBlob);
        // }
      } else {
        console.error(
          "Response not okay:",
          response.status,
          response.statusText
        );
        setMicStatus(true);
      }
    }
  };
  const pauseAudio = () => {
    const audioPlayer = document.getElementById("audioPlayer");
    if (!audioPlayer.paused) {
      audioPlayer.pause();
    }
    playingRef.current = false;
    setMicStatus(true);
    setIsSpeaking(false);
  };
  const ReplayIcon = ({
    message,
    index,
    currentPlayingIndex,
    setCurrentPlayingIndex,
  }) => {
    const isPlaying = currentPlayingIndex === index;
    const handleReplayClick = () => {
      if (isPlaying) {
        pauseAudio();
        setCurrentPlayingIndex(null);
      } else {
        pauseAudio();
        setCurrentPlayingIndex(index);
        customerName?.toLowerCase() === "sue"
          ? replaySoulAvatar(customerName?.toLowerCase(), message)
          : getAudio(customerName?.toLowerCase(), message);
      }
    };
    return (
      <>
        <OverlayTrigger placement="bottom" overlay={replayTooltip}>
          <button
            className={`btn btn-link `}
            onClick={() => {
              setIsSpeaking(true);
              handleReplayClick();
              // playVoice(message);
            }}
          >
            {isPlaying ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="rgba(45,45,45,1)"
              >
                {/* Pause Icon */}
                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM9 8C9 7.44772 9.44772 7 10 7H11C11.5523 7 12 7.44772 12 8V16C12 16.5523 11.5523 17 11 17H10C9.44772 17 9 16.5523 9 16V8ZM13 8C13 7.44772 13.4477 7 14 7H15C15.5523 7 16 7.44772 16 8V16C16 16.5523 15.5523 17 15 17H14C13.4477 17 13 16.5523 13 16V8Z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="rgba(45,45,45,1)"
              >
                {/* Play Icon */}
                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z" />
              </svg>
            )}
          </button>
        </OverlayTrigger>
      </>
    );
  };
  return (
    <>
      <div className="container-wrapper position-relative">
        <div className="chat-container d-flex flex-column">
          {/* <div className="chat-header p-2 d-flex align-items-center justify-content-between">
                  <div>
                    <button className="builder-btn" onClick={feedbackHandler}>
                Share Feedback
              </button>
                    <button
                              className="btn p-1"
                              style={{ color: "white", marginLeft: "10px", fontSize: "26px" }}
                              onClick={handleClosePlugin}
                          >
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#ffffff"><path d="M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z"></path></svg>
                          </button>
                  </div>
                </div> */}
          <div
            className="chat-body flex-grow-1 overflow-auto"
            ref={chatMessagesRef}
          >
            {(messages.length > 0 || (messages.length == 0 && loading)) && (
              <ul className="chat-messages">
                {messages.map((message, index) =>
                  typeof message.message !== "undefined" &&
                  message.message.length > 0 ? (
                    <li className={`message-row ${message.type}`} key={index}>
                      <div className="user-avtar rounded-circle">
                        {/* <img src="/images/AI_Icon.svg" width={40} height={40} /> */}
                        <div className="d-flex gap-2">
                          <div className="time-ai">{message.time}</div>
                          <div className="system-ai">
                            {message.type === "system"
                              ? message?.userName || title
                              : message.type === "user"
                              ? message.userName || "You"
                              : null}
                          </div>
                        </div>
                      </div>
                      <div className="inner-message">
                        {!markFlag ? (
                          <div className="chat-wrap">
                            {typeof message.message !== "undefined" &&
                              message.message.length > 0 && (
                                <ReactMarkdown
                                  children={message.message}
                                  remarkPlugins={[remarkGfm]}
                                  components={{
                                    a: ({ href, children, ...props }) => (
                                      <a
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        {...props}
                                      >
                                        {children}
                                      </a>
                                    ),
                                  }}
                                  className={`message-${index}`}
                                />
                              )}
                            {message.type != "system" && index != 0 && (
                              <div className="reset-box-copy">
                                <Tooltipcomponent
                                  title={t("resend")}
                                  child={
                                    <div
                                      className="context-name copy-btn"
                                      onClick={() => {
                                        setUserMessage(message.message);
                                      }}
                                      style={
                                        loading || isStreaming
                                          ? {
                                              pointerEvents: "none",
                                              opacity: "0.5",
                                            }
                                          : {}
                                      }
                                    >
                                      <img
                                        src="/images/resend.svg"
                                        alt={t("resend")}
                                      />
                                    </div>
                                  }
                                />
                              </div>
                            )}
                            {message.type == "system" && index != 0 && (
                              <div className="reset-box-copy">
                                {shouldShowAudioIcon &&
                                  (() => {
                                    const isPlaying =
                                      currentPlayingIndex === index;

                                    const handleReplayClick = () => {
                                      if (isPlaying) {
                                        pauseAudio();
                                        setCurrentPlayingIndex(null);
                                      } else {
                                        pauseAudio();
                                        setCurrentPlayingIndex(index);
                                        customerName?.toLowerCase() === "sue"
                                          ? replaySoulAvatar(
                                              customerName?.toLowerCase(),
                                              message
                                            )
                                          : getAudio(
                                              customerName?.toLowerCase(),
                                              message
                                            );
                                      }
                                    };

                                    return (
                                      <OverlayTrigger
                                        key={index}
                                        placement="bottom"
                                        overlay={replayTooltip(isPlaying)}
                                      >
                                        <button
                                          className="btn btn-link"
                                          onClick={() => {
                                            handleReplayClick();
                                          }}
                                        >
                                          {isPlaying ? (
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 24 24"
                                              width="24"
                                              height="24"
                                              fill="rgba(45,45,45,1)"
                                            >
                                              <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM9 8C9 7.44772 9.44772 7 10 7H11C11.5523 7 12 7.44772 12 8V16C12 16.5523 11.5523 17 11 17H10C9.44772 17 9 16.5523 9 16V8ZM13 8C13 7.44772 13.4477 7 14 7H15C15.5523 7 16 7.44772 16 8V16C16 16.5523 15.5523 17 15 17H14C13.4477 17 13 16.5523 13 16V8Z" />
                                            </svg>
                                          ) : (
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 24 24"
                                              width="24"
                                              height="24"
                                              fill="rgba(45,45,45,1)"
                                            >
                                              <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z" />
                                            </svg>
                                          )}
                                        </button>
                                      </OverlayTrigger>
                                    );
                                  })()}

                                <Tooltipcomponent
                                  title={t("copy")}
                                  child={
                                    <div
                                      className="context-name copy-btn"
                                      onClick={() => {
                                        const element =
                                          document.getElementsByClassName(
                                            `message-${index}`
                                          )[0];

                                        if (!element) {
                                          toast.error(t("somethingwentwrong"));
                                          return;
                                        }

                                        let textContent = element.innerText;
                                        navigator.clipboard
                                          .writeText(textContent)
                                          .then(() => {
                                            toast.success(t("copied"));
                                          })
                                          .catch(() => {
                                            toast.error(
                                              t("somethingwentwrong")
                                            );
                                          });
                                      }}
                                    >
                                      <img
                                        src="/images/copy.svg"
                                        alt={t("copy")}
                                      />
                                    </div>
                                  }
                                />

                                {(message.message.indexOf("<!DOCTYPE html>") !=
                                  -1 ||
                                  message.message.indexOf("<html>") != -1) && (
                                  <Tooltipcomponent
                                    title={t("preview")}
                                    child={
                                      <div
                                        className="context-name copy-btn"
                                        onClick={() =>
                                          onPreviewClickHandler(message.message)
                                        }
                                      >
                                        <img
                                          src="/images/preview.svg"
                                          alt={t("preview")}
                                        />
                                      </div>
                                    }
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <pre>
                            <div
                              className="chat-wrap"
                              dangerouslySetInnerHTML={{
                                __html: Utils.formatedString(message.message),
                              }}
                            />
                          </pre>
                        )}
                      </div>
                    </li>
                  ) : null
                )}
                {userMessage && (
                  <li className={`message-row user`}>
                    <div className="user-avtar rounded-circle d-flex gap-2">
                      <div className="time-ai">
                        {moment().format("DD/MM/YYYY hh:mm A")}
                      </div>
                      <div className="system-ai">You</div>
                    </div>
                    <div className="inner-message">
                      <pre>
                        <div
                          className="chat-wrap pb-3"
                          dangerouslySetInnerHTML={{
                            __html:
                              Utils.formattedStringUserMessage(userMessage),
                          }}
                        />
                      </pre>
                    </div>
                  </li>
                )}

                {loading && !currentChunk ? (
                  <li className={`message-row system`}>
                    <div className="user-avtar rounded-circle d-flex gap-2">
                      {/* <img src="/images/Avatar.png" width={40} height={40} /> */}
                      <div className="time-ai">
                        {moment().format("DD/MM/YYYY  hh:mm A")}
                      </div>
                      <div className="system-ai">{title}</div>
                      {/* <img src="/images/AI_Icon.svg" width={40} height={40} /> */}
                    </div>
                    <div className="inner-message">
                      <div className="d-flex w-100 gap-2 align-items-center justify-content-center">
                        <div className="loader"></div>
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                )}

                {currentChunk && (
                  <li className={`message-row system`}>
                    <div className="user-avtar rounded-circle d-flex gap-2">
                      <div className="time-ai">
                        {moment().format("DD/MM/YYYY hh:mm A")}
                      </div>
                      <div className="system-ai">{title}</div>
                    </div>
                    <div className="inner-message">
                      {!markFlag ? (
                        <div className="chat-wrap">
                          <TypeText
                            text={currentChunk}
                            delay={5}
                            setIsStreaming={() => {
                              // handleloaded(currentChunk)
                            }}
                            isStreaming={isStreaming}
                            needScroll={needScroll}
                            scrollToBottom={scrollToBottom}
                          />
                        </div>
                      ) : (
                        <pre>
                          <div
                            className="chat-wrap"
                            dangerouslySetInnerHTML={{
                              __html: Utils.formatedString(currentChunk),
                            }}
                          />
                        </pre>
                      )}
                    </div>
                  </li>
                )}
              </ul>
            )}
            {audioMessage && (
              <li className={`message-row user`}>
                <div className="user-avtar rounded-circle d-flex gap-2">
                  <div className="time-ai">
                    {moment().format("DD/MM/YYYY hh:mm A")}
                  </div>
                  <div className="system-ai">You</div>
                </div>
                <div className="inner-message">
                  <pre>
                    <div
                      className="chat-wrap pb-3"
                      dangerouslySetInnerHTML={{
                        __html: Utils.formattedStringUserMessage(audioMessage),
                      }}
                    />
                  </pre>
                </div>
              </li>
            )}
          </div>
          <div
            className={
              outputType === "audio" ? "chat-footer mt-3" : "chat-footer"
            }
          >
            {chunkFlag && (
              <div
                className={`${
                  loading || isStreaming ? "chunk-rapper-diabled" : ""
                } chunk-rapper dropper mb-3 position-relative`}
              >
                <div className="row row-gap-3 mb-3 4col-row">
                  {chunkFlag &&
                    !visible &&
                    chunks.length != 0 &&
                    chunks.slice(0, 4).map((chunk, index) => {
                      return (
                        <div className="col-md-6 fade-in">
                          <button
                            key={index}
                            // variant={
                            //   loading || isStreaming ? "secondary" : "primary"
                            // }
                            className="table-btn"
                            onClick={(e) => setPrompt(chunk)}
                            disabled={loading || isStreaming}
                            title={chunk?.msgChunks}
                            style={
                              loading || isStreaming
                                ? { pointerEvents: "none", opacity: "0.5" }
                                : {}
                            }
                          >
                            {chunk?.msgChunks}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="rgba(0,0,0,1)"
                            >
                              <path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path>
                            </svg>
                          </button>
                        </div>
                      );
                    })}
                </div>
                {chunks.length > 4 && (
                  <>
                    <div
                      className={`rowwa ${
                        !visible ? "d-none fade" : "d-block fade-in"
                      }`}
                    >
                      <div className="row chunk-rapper mt-3">
                        {chunks.map((chunk, index) => {
                          return (
                            <div className="col-md-6">
                              <button
                                key={index}
                                // variant={
                                //   loading || isStreaming ? "secondary" : "primary"
                                // }
                                className="table-btn"
                                onClick={() => {
                                  toggleVisibility();
                                  setPrompt(chunk);
                                }}
                                disabled={loading || isStreaming}
                                title={chunk?.msgChunks}
                                style={
                                  loading || isStreaming
                                    ? { pointerEvents: "none", opacity: "0.5" }
                                    : {}
                                }
                              >
                                {chunk?.msgChunks}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  height="24"
                                  fill="rgba(0,0,0,1)"
                                >
                                  <path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path>
                                </svg>
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="btnbox-more">
                      <button
                        className="read-btn"
                        onClick={() => {
                          toggleVisibility();
                          if (!visible && needScroll) {
                            scrollToBottom();
                          }
                        }}
                        disabled={loading || isStreaming}
                        style={
                          loading || isStreaming
                            ? { pointerEvents: "none", opacity: "0.5" }
                            : {}
                        }
                      >
                        {t(!visible ? "showMore" : "showLess")}
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
            {/* {(outputType === "audio" || outputType === "both") && (
              <>
                {isUserSpeaking && isMicOn && (
                  <section className="record-box w-100 d-flex justify-content-center">
                    <div className="loader">
                      <svg
                        id="wave"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 50 38.05"
                      >
                        <title>{t("audioWave")}</title>
                        <path
                          id="Line_1"
                          data-name="Line 1"
                          d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"
                        />
                        <path
                          id="Line_2"
                          data-name="Line 2"
                          d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"
                        />
                        <path
                          id="Line_3"
                          data-name="Line 3"
                          d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"
                        />
                        <path
                          id="Line_4"
                          data-name="Line 4"
                          d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"
                        />
                        <path
                          id="Line_5"
                          data-name="Line 5"
                          d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"
                        />
                        <path
                          id="Line_6"
                          data-name="Line 6"
                          d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z"
                        />
                        <path
                          id="Line_7"
                          data-name="Line 7"
                          d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z"
                        />
                        <path
                          id="Line_8"
                          data-name="Line 8"
                          d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z"
                        />
                        <path
                          id="Line_9"
                          data-name="Line 9"
                          d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z"
                        />
                      </svg>
                    </div>
                  </section>
                )}
              </>
            )} */}
            <div className="d-flex align-items-center gap-3 justify-content-center">
              {(outputType === "text" ||
                outputType === "both" ||
                outputType === "input") && (
                <div
                  className={`text-areabox position-relative chat-text-area w-100 ${
                    outputType === "both" && isMicOn ? "disabled" : ""
                  }`}
                >
                  <textarea
                    id="question"
                    name="question"
                    placeholder="Enter input here ..."
                    className="form-control mb-2"
                    cols="40"
                    row="6"
                    ref={inputRef}
                    autoFocus={true}
                    onInput={(e) => {
                      // File suggestion logic FIRST
                      handleFileSuggestions(e.target.value);

                      // Existing mic logic SECOND
                      if (outputType === "both") {
                        setResetText(e.target.value);
                        micRef.current?.resetTranscript();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        if (e.altKey) {
                          e.preventDefault();
                          const textarea = e.target;
                          const start = textarea.selectionStart;
                          const end = textarea.selectionEnd;
                          const value = textarea.value;
                          const newValue =
                            value.substring(0, start) +
                            "\n" +
                            value.substring(end);
                          textarea.value = newValue;

                          if (outputType === "both") {
                            setResetText(newValue);
                            micRef.current?.resetTranscript();
                          }

                          requestAnimationFrame(() => {
                            textarea.selectionStart = textarea.selectionEnd =
                              start + 1;
                          });
                        } else if (!e.shiftKey) {
                          e.preventDefault();
                          onSubmit(e);
                        }
                      }
                    }}
                    style={
                      loading || isStreaming ? { pointerEvents: "none" } : {}
                    }
                  />
                  {showSuggestions && (
                    <div
                      className="position-absolute bg-white border shadow rounded p-1 mt-1"
                      style={{
                        zIndex: 9999,
                        maxHeight: "200px",
                        overflowY: "auto",
                        minWidth: "300px",
                        left: 0,
                        top: "50%",
                        bottom: "-150%",
                      }}
                    >
                      {fileSuggestions.map((file, index) => (
                        <div
                          key={file._id || index}
                          className="p-2 border-bottom hover-bg-light cursor-pointer"
                          onClick={() => handleFileSelect(file.fileName)}
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <span className="text-truncate">{file.fileName}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  <button
                    //variant="primary"
                    className="chat-text-btn"
                    onClick={(e) => {
                      if (loading || isStreaming) {
                        terminateRequest();
                      } else {
                        onSubmit(e);
                      }
                    }}
                  >
                    <img
                      src={`/images/${
                        loading || isStreaming ? "stop.svg" : "arrow.svg"
                      }`}
                      alt={loading || isStreaming ? "Stop" : "Send"}
                    />
                  </button>
                </div>
              )}
              {(outputType === "audio" || outputType === "both") && (
                <div
                  className={`position-relative mic-wrap d-flex justify-content-center flex-wrap`}
                >
                  {/* <OverlayTrigger
                    overlay={
                      <Tooltip id="tooltip-disabled">
                        {userSpeaking && isMicOn ? "Recording" : "Record"}
                      </Tooltip>
                    }
                  > */}
                  <HandleWithMic
                    ref={micRef}
                    isMicOn={isMicOn}
                    setIsMicOn={setIsMicOn}
                    activeTab={activeTab}
                    outputType={outputType}
                    micStatus={micStatus}
                    loading={loading}
                    isStreaming={isStreaming}
                    inputRef={inputRef}
                    pauseAudio={pauseAudio}
                    setCurrentPlayingIndex={setCurrentPlayingIndex}
                    isSpeaking={isSpeaking}
                    resetText={resetText}
                    autoSubmit={autoSubmit}
                    handleInterrupt={handleInterrupt}
                    setAudioMessage={setAudioMessage}
                  />
                  {/* </OverlayTrigger> */}
                </div>
              )}
            </div>
            <label
              htmlFor="question"
              className={`discrptionc d-block mt-2 ${
                outputType === "audio" ? "text-center" : "text-center"
              }`}
            >
              {t("textChatAssistantPara1")}
            </label>
          </div>
        </div>
      </div>

      <ThemeModal
        modelSize={"xs"}
        show={show}
        Heading={modalHeading}
        onClose={() => {
          setShow(false);
          setModalHeading("Preview");
        }}
        list={chunks}
        setPrompt={(e) => setPrompt(e)}
        html={previewData}
      />
      <div className="audioplayer" style={{ visibility: "hidden" }}>
        <audio id="audioPlayer" ref={audioRef} controls></audio>
      </div>
    </>
  );
};

export default TextChatAssistant;
